import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { WhatsappSender } from './components';

const routes = () => (
  <PrivateRoute
    exact
    path="/settings/whatsapp-sender"
    component={WhatsappSender}
  />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsAppSender/routes.js